import { render, staticRenderFns } from "./DepartmentSelector.vue?vue&type=template&id=28c41bd8&"
import script from "./DepartmentSelector.vue?vue&type=script&lang=js&"
export * from "./DepartmentSelector.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VListItem,VListItemContent,VListItemTitle,VSelect})
